import React, {Component} from 'react'
// import * as firebase from 'firebase';
import firebase from '../helper/firebase'
import {Link} from 'react-router-dom'

import {
  // Avatar,
  Badge,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Paper,
} from 'material-ui'

import Grow from 'material-ui/transitions/Grow';

import NotificationsIcon from 'material-ui-icons/Notifications'
import DeleteIcon from 'material-ui-icons/Delete'

import Fade from 'material-ui/transitions/Fade'

import '../styles/ToolbarMenuIcon.css'

const style = {
  toolbarMenuIcon:{
    marginLeft:'9px',
  }
}

export default class ToolbarMenuNotificationIcon extends Component{
  constructor(props){
    super(props);

    this.state = {
      open:false,
    }
  }

  handleMenuIconClick=()=>{
    this.setState({
      open:!this.state.open,
    })
  }

  handleRequestClose=()=>{
    this.setState({open:false})
  }

  renderNotifications=()=>{
    const {notifications} = this.props;
    let html = [];
    if(Object.keys(notifications).length===0){
      let item = (
        <ListItem onClick={this.handleRequestClose} button >
          <ListItemText primary='No Notifications' />
        </ListItem>
      )
      html.push(item);
      return html;
    }
    else{
      Object.keys(notifications).forEach(nid=>{
        let item = (
            <ListItem onClick={this.handleMenuIconClick} key={nid} button>
              <Link to={notifications[nid].click_action} >
                <ListItemText primary={`${notifications[nid].click_title}`} secondary={`${notifications[nid].title}`} />
              </Link>
              <ListItemSecondaryAction>
                <IconButton onClick={()=>{this.deleteNotification(nid)}} aria-label="Delete">
                  <DeleteIcon />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
        )
        html.push(item)
        if(Object.keys(notifications).indexOf(nid)!==Object.keys(notifications).length-1){
          html.push(<Divider key={`${nid}_divider`} light />)
        }
      })
      return html;
    }
  }

  deleteNotification=(nid)=>{
    console.log(nid);
    const ref = firebase.database().ref();
    ref.child(`userNotifications/${this.props.uid}/${nid}`).set(null)
  }

  render(){
    return(
      <div style={style.toolbarMenuIcon} className="toolbarMenuIcon">
        <Grow in={true} >
          <IconButton onClick={this.handleMenuIconClick} color="contrast" aria-label="Notifications">
            <Badge badgeContent={Object.keys(this.props.notifications).length} color="accent">
              <NotificationsIcon />
            </Badge>
          </IconButton>
        </Grow>
        {this.state.open?
          <Fade
            in={this.state.open}
          >
            <Paper
              elevation={10}
              className='menu'
            >
              <List>
                {this.renderNotifications()}
              </List>
            </Paper>
          </Fade>
        :
          null
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ToolbarMenuNotificationIcon.js